module.exports = __webpack_public_path__ + "static/media/demo-1.9fd71c78.jpg";